import type { ObjectFilterGroup } from "./types";
import { isFilterCondition, isConditionComplete } from "./utils";

export const countRules = (filter: ObjectFilterGroup | undefined): number => {
  if (!filter) return 0;

  let count = 0;

  // Iterate through conditions array which contains both conditions and nested groups
  filter.conditions?.forEach(item => {
    if (isFilterCondition(item)) {
      if (isConditionComplete(item)) {
        count += 1;
      }
    } else if ("type" in item && "conditions" in item) {
      // This is a nested group - recursively count its rules
      count += countRules(item);
    }
  });

  return count;
};
